const currentCustomer = require('../customer.js');
export const config = require(`./${currentCustomer}.js`).default;
